import classNames from "classnames";
import { NavigationModel } from "models/NavigationModel";
import { useNavigate } from "react-router";

interface HeaderNavItemProps {
  className?: string;
  item: NavigationModel;
}

export const HeaderDropdownItem: React.FC<HeaderNavItemProps> = ({ className = "dropdown-item", item }) => {
  const navigate = useNavigate();

  function handleClick(item: NavigationModel) {
    const { onClick, href, target } = item;
    if (href) {
      if (href.includes("://")) {
        if (target === "_blank") {
          window.open(href);
        } else {
          window.location.href = href;
        }
      }
      navigate(href);
      return;
    }

    if (onClick) {
      onClick();
      return;
    }

    throw new Error("Empty href and onClick");
  }

  className = classNames(className, item.isSelected ? "active" : "");
  return (
    <button className={className} onClick={() => handleClick(item)}>
      {item.iconStart ? <div className="sbb-header-nav-item-icon me-2">{item.iconStart}</div> : null}
      {item.text}
      {item.iconEnd ? <div className="sbb-header-nav-item-icon ms-2">{item.iconEnd}</div> : null}
    </button>
  );
};
